import { get } from 'lodash';
import { graphqlRequest } from '../urql';
import { getCommunityTagsQuery, getSectionTagsQuery } from './queries';
import { isOk } from '@/common/utils';

export const getSectionTagsApi = async id => {
  const res = await graphqlRequest(getSectionTagsQuery, { id });
  if (!isOk(res)) return [];
  const tags = get(res, 'data.book_section.tags', []);
  return tags;
};

export const getCommunityTagsApi = async id => {
  const res = await graphqlRequest(getCommunityTagsQuery, { id });
  if (!isOk(res)) return [];
  const tags = get(res, 'data.community.tags', []);
  return tags;
};
